import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_24: FaireProductEntity = {
  token: "legacy_prod_abbott-24",
  type: "product",
  name: "Nepal 90",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1257f3d4a4836206a0832577c8d446e6a8fd75b9ad3248fc88d00eceb4106ef0.jpeg",
  priceDollars: 28,
  subcategory: "Outdoor Decor",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
